"use client";

import { usePathname } from "next/navigation";
import styles from "./navbar.module.css";
import Link from "next/link";
import Logo from "@/components/icons/Logo";
import Chevron from "@/components/icons/Chevron";

export const NavbarWrapper = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();
  const isCheckout =
    pathname.includes("checkout") && !pathname.includes("summary");

  if (isCheckout)
    return (
      <header className={`${styles.navWrapper} navigation-bar`}>
        <nav className={styles.nav}>
          <Link href={"/"} className={styles.back}>
            <Chevron />
            {"Back to store"}
          </Link>
          <div className={styles.logo}>
            <Link href="/">
              <Logo />
              <span className="sr-only">Home</span>
            </Link>
          </div>
        </nav>
      </header>
    );

  return (
    <header className={`${styles.navWrapper} navigation-bar`}>
      {children}
    </header>
  );
};
